interface LockStatusProps {
  lockedBy: string;
  canUnlock: boolean;
  onUnlock: (id: string) => void;
  id?: string;
  ariaLabel?: string;
}

function LockStatus({
  lockedBy, onUnlock, canUnlock, ariaLabel, id,
}: LockStatusProps) {
  return (
    <div data-testid="lock-status">
      <div className="nhsuk-caption-s nhsuk-u-secondary-text-colour ">
        Locked by
        {' '}
        {lockedBy}
        {' '}
        <span className="nhsuk-u-padding-left-1">
          <img src="/locked.svg" alt="Locked" />
        </span>
      </div>
      {canUnlock && (
        <button
          type="button"
          className="nhs-link-button"
          onKeyDown={(e) => e.key === 'Enter' && onUnlock(id as string)}
          data-testid="unlock-button"
          onClick={() => onUnlock(id as string)}
          aria-label={ariaLabel || 'Unlock campaign'}
        >
          Unlock
        </button>
      )}
    </div>
  );
}

export default LockStatus;
